<template>
  <div class="address-input">
    <div class="form-group" :class="{ 'has-feedback' : field.dirty }">
      <label :for="field.name" class="col-sm-4 control-label has-icon has-icon-address">{{ field.label }}</label>
      <div :class="field.label ? 'col-sm-8' : 'col-sm-12'">
        <input v-show="!field.hiddenBar" placeholder="Enter an address" class="form-control google-autocomplete" :id="field.name" type="text" v-model="field.value" :name="field.name">
        <input type="hidden" :id="field.name + '_latitude'" :name="field.name + '_latitude'" :value="field.latitude"/>
        <input type="hidden" :id="field.name + '_longitude'" :name="field.name + '_longitude'" :value="field.longitude"/>
        <span class="form-validation-info" v-show="loading">Looking up address...</span>
        <span class="form-validation-error" v-show="!isLength && field.dirty">{{ field.label }} is too short.</span>
        <span class="form-validation-error" v-show="googleError && field.dirty">{{ googleError }}</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
    <div class="form-group" v-show="!field.hiddenMap">
      <div :class="field.label ? 'col-sm-8 col-sm-offset-4' : 'col-sm-12'">
        <div :id="field.name + '_map'" style="height:300px;"></div>
        <span class="map-info">Latitude: {{ field.latitude }}, Longitude: {{ field.longitude }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          name: '',
          value: '',
          latitude: 0,
          longitude: 0,
          valid: false,
          dirty: false,
          hiddenBar: false,
          hiddenMap: false
        }
      }
    }
  },
  data () {
    return {
      googleError: false,
      isLength: false,
      isRegex: false,
      minLength: 5,
      preventLookup: false,
      marker: null,
      map: null,
      loading: false,
      noClick: false
    }
  },
  ready () {
    this.googleError = false
    let geocoder = new google.maps.Geocoder()
    this.map = new google.maps.Map(document.getElementById(`${this.field.name}_map`), {
      center: {lat: this.field.latitude, lng: this.field.longitude},
      zoom: 13
    })
    google.maps.event.addListener(this.map, 'idle', () => {
      google.maps.event.trigger(this.map, 'resize')
    })
    let input = document.getElementById(this.field.name)
    let searchBox = new google.maps.places.SearchBox(input)
    this.map.addListener('bounds_changed', () => {
      searchBox.setBounds(this.map.getBounds())
    })
    searchBox.addListener('places_changed', () => {
      let places = searchBox.getPlaces()
      if (places.length === 0) {
        return
      }
      this.field.value = places[0].formatted_address || places[0].name
      this.field.latitude = places[0].geometry.location.lat()
      this.field.longitude = places[0].geometry.location.lng()
      if (this.marker) this.marker.setMap(null)
      this.marker = new google.maps.Marker({
        position: places[0].geometry.location,
        draggable: true,
        animation: google.maps.Animation.DROP,
        map: this.map
      })
      this.map.panTo(places[0].geometry.location)
      this.map.setZoom(16)
    })
    if (!this.field.noClick) {
      this.map.addListener('click', (event) => {
        this.googleError = false
        if (this.marker) this.marker.setMap(null)
        this.marker = new google.maps.Marker({
          position: event.latLng,
          draggable: true,
          animation: google.maps.Animation.DROP,
          map: this.map
        })
        this.field.latitude = event.latLng.lat()
        this.field.longitude = event.latLng.lng()
        this.marker.addListener('dragend', (event) => {
          this.field.latitude = event.latLng.lat()
          this.field.longitude = event.latLng.lng()
        })
        this.loading = true
        geocoder.geocode({'location': event.latLng}, (results, status) => {
          this.loading = false
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              this.preventLookup = true
              this.field.value = results[0].formatted_address
            } else {
              this.googleError = 'No results found'
            }
          } else {
            this.googleError = `Geocode was not successful for the following reason: ${status}`
          }
        })
      })
    }
    if (this.field.value) {
      this.marker = new google.maps.Marker({
        position: { lat: this.field.latitude, lng: this.field.longitude },
        draggable: true,
        animation: google.maps.Animation.DROP,
        map: this.map
      })
      this.marker.addListener('dragend', (event) => {
        this.field.latitude = event.latLng.lat()
        this.field.longitude = event.latLng.lng()
      })
      this.map.panTo({ lat: this.field.latitude, lng: this.field.longitude })
      this.map.setZoom(16)
    }
  },
  events: {
    'modal-opened': function () {
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        google.maps.event.trigger(this.map, 'resize')
        this.map.panTo({ lat: this.field.latitude, lng: this.field.longitude })
      })
    },
    updateMarker (newMarker) {
      if (this.marker) this.marker.setMap(null)
      this.marker = new google.maps.Marker({
        position: { lat: newMarker.lat, lng: newMarker.lng },
        draggable: true,
        animation: google.maps.Animation.DROP,
        map: this.map
      })
      this.field.latitude = newMarker.lat
      this.field.longitude = newMarker.lng
      this.field.value = newMarker.address
      this.map.panTo({ lat: this.field.latitude, lng: this.field.longitude })
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddressInput.vue?4f1a9117